import { faBox } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface BoxIconProps {
  className?: string;
}

export const BoxIcon = ({ className = '' }: BoxIconProps) => {
  return <FontAwesomeIcon icon={faBox} className={className} />;
};
